import { useEffect, useState } from 'react';

export function useHeaderHeight() {
  const [headerHeight, setHeaderHeight] = useState(116);

  useEffect(() => {
    const updateHeaderHeight = () => {
      const navbar = document.querySelector('[data-component="NavBar"]');
      if (navbar) {
        const height = navbar.getBoundingClientRect().height;
        setHeaderHeight(height);
      }
    };

    // Update on mount
    updateHeaderHeight();

    // Update on window resize
    window.addEventListener('resize', updateHeaderHeight);

    // Update when banners might change (using MutationObserver)
    const observer = new MutationObserver(updateHeaderHeight);
    const navbar = document.querySelector('[data-component="NavBar"]');
    if (navbar) {
      observer.observe(navbar, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    }

    return () => {
      window.removeEventListener('resize', updateHeaderHeight);
      observer.disconnect();
    };
  }, []);

  return headerHeight;
}
